import { apiGet, buildApiURL } from '@src/services/api';

const getStates = () => {
    return apiGet(buildApiURL('/api/v1/states'));
};

const getAllStates = () => {
    return apiGet(buildApiURL('/api/v1/states/all'));
};

export { getAllStates, getStates };
